import { createFileRoute } from "@tanstack/react-router";
import AdminAnnouncements from "@/pages/AdminAnnouncements";

export const Route = createFileRoute("/_owner/owner/announcements/")({
  component: AdminAnnouncements,
});
